<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head" id="fm01-001"><b>DEDICATION</b></p>
<p class="dedicat"><i>For my family:</i></p>
<p class="txt"><span class="txt_blue">To my husband, Sam,</span> who always wanted me to write a book … though I’m quite certain this wasn’t what you had in mind.</p>
<p class="txt"><span class="txt_blue">To my three joyful, fiery, and nonpareil daughters</span>—Jettie, Florence, and Nell—you are pure bliss.</p>
<p class="txt"><span class="txt_blue">To my siblings</span>, for all the love.</p>
<p class="txt"><span class="txt_blue">And to my parents</span>, for affording me the desire to fish (and for teaching me to quilt—thanks, Mom).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedication.vue?5297f67f